import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class ShipmentResource extends AuthenticatedResource {
  static urlRoot = 'organizations/:organization_id/shipments' as const;

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
